import { mutatorAction } from 'satcheljs';
import getRegionalOptions from '../store/store';
export default mutatorAction('setSupportedTimeZones', function setSupportedTimeZones(supportedTimeZones) {
    var regionalOptions = getRegionalOptions();
    regionalOptions.supportedTimeZones = supportedTimeZones;
});
//# sourceMappingURL=setSupportedTimeZones.js.map